import { render } from "./primary_button_error.vue?vue&type=template&id=501bb1ef&ts=true"
import script from "./primary_button_error.vue?vue&type=script&lang=ts"
export * from "./primary_button_error.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__